// VSDigi complaints: open the sale bill (invoice PDF) in a new tab.
// Bills are generated only when someone asks to see one.

const INVOICE_URL = 'https://ss.graddev.in/api/invoice1'

// The tab is opened straight away, inside the click, so the browser does not
// block it as a popup; the PDF is loaded into it once it arrives.
function withTab(load) {
	const tab = window.open('', '_blank')
	return load()
		.then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
			if (tab) {
				tab.location.href = url
			} else {
				window.location.href = url
			}
		})
		.catch((error) => {
			if (tab) tab.close()
			throw error
		})
}

function fetchBill(saletransactionid) {
	return window.axios.post(INVOICE_URL, { transactionid: saletransactionid }, { responseType: 'blob' })
}

export function openBill(saletransactionid) {
	return withTab(() => fetchBill(saletransactionid))
}

// The sale behind an existing complaint is looked up only when its bill is asked for.
export function openComplaintBill(complaintId) {
	return withTab(() =>
		window.axios
			.post(`api/vsdigi/complaints/${complaintId}/sale`)
			.then((response) => fetchBill(response.data.data.saletransactionid))
	)
}

export function billError(error) {
	return (error && error.response && error.response.data && error.response.data.message) || 'Could not open the bill.'
}
